import { User } from '../user';
import { mapCollection } from '../../utils/collection.utils';
import { RoleBuilder } from './role.builder';
import { WorkingShiftBuilder } from './working-shift.builder';

export class UserBuilder {
  static fromJson(json): User {
    return (json)
      ? new User(
        json.hash,
        json.firstName,
        json.lastName,
        json.email,
        RoleBuilder.fromJson(json.role),
        json.reference,
        json.section,
        json.active,
        WorkingShiftBuilder.fromJson(json.workingShift),
        json.workingShiftName
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(UserBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/user.builder.ts